import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksFinantech.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksFinantech = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://www.instagram.com"
      hasMarginRight
    />
    <Icon
      iconName={faFacebook}
      link="https://www.facebook.com"
      hasMarginRight
    />
    <Icon iconName={faYoutube} link="https://www.youtube.com" />
  </SocialNetworkContainer>
);
